import RichTextEditor from './tiptap-templates/simple/simple-editor'

type Props = {
  value?: string
  onChange?: (value: string) => void
  mode?: 'simple' | 'full'
  disabled?: boolean
}

const TipTapEditor = ({
  value,
  onChange,
  mode = 'simple',
  disabled,
}: Props) => (
  <RichTextEditor
    value={value}
    onChange={onChange}
    mode={mode}
    disabled={disabled}
  />
)

export default TipTapEditor
